import "./App.css";
import AboutUs from "./components/AboutUs";
import AdvisoryBoard from "./components/AdvisoryBoard";
import ClgInfo from "./components/ClgInfo";
import Footer from "./components/OurFooter";
import OurInstituions from "./components/instituions";
import NavBar from "./components/NavBar";
import NavImageSlider from "./components/NavImageSlider";
import OurProgram from "./components/OurProgram";
import OurTeam from "./components/OurTeam";
import OurFooter from "./components/OurFooter";



function App() {
  return (
    <>
      <NavBar />
      <NavImageSlider />
      <AdvisoryBoard />
      <ClgInfo />
      <AboutUs />
      <OurTeam/>
      <OurInstituions />
      <OurProgram />
     <OurFooter/>
        </>
  );
}

export default App;
